import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  Component,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  Renderer2,
  inject
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/@core/services/auth.service';
import { LocalService } from '@app/@core/services/local.service';
import { SocketAdapterService } from '@app/@core/services/socket-adapter.server';
import { ThemeService } from '@app/@core/services/theme.service';
import { ProfileService } from '@app/shared/modules/profile/profile.service';
import { CustomValidator } from '@app/shared/validator/custom-validator';
import { AppConstants } from '@core/entities/app-constants';
import { AlertService } from '@core/services/alert.service';
import { AppService } from '@core/services/app.service';
import { environment } from '@env/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, interval, Subscription } from 'rxjs';
import { ChatService } from './pics-lib/chat/@core/services/chat.service';
import { MailNotificationService } from './pics-lib/main-notification/@core/main-notification.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { MAIN_NOTIFICATION_TIMER } from './pics-lib/main-notification/@core/main-notification.config';
import { Title } from '@angular/platform-browser';
import { page_title } from '@app/page.title';

declare const $: any;
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: false
})
export class PagesComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('notificationAlert', { static: false }) private notificationAlert;
  @ViewChild('langInput') langInput: ElementRef;
  @ViewChild('accept') accept: ElementRef;
  @ViewChild('langselect') langselect: ElementRef;

  currentPage?: any;
  username: any;
  showname: any;
  userDetails: any;
  resetPasswordForm!: FormGroup;
  display = false;
  thumbnail!: string;
  isValid = false;
  visibleSidebar2;
  activityLogPageload: Promise<boolean> | undefined;
  active = false;
  completevalue = 80;
  showCount = true;
  notificationCount = 0;
  sidebarMenu = true;
  alertService: AlertService;
  appService: AppService;
  orgOptions: any = [];
  selectedOrg: any;
  disable: boolean;
  orgName: any;
  themes: any = [];
  fontSetList: any = [];
  selectedTheme: any;
  selectedFont: any;
  themeService: ThemeService;
  localstorage: LocalService;
  rocketIcon: string;
  pageIcon: string;
  statuses: any = [];
  selectedStatus: any;
  notificationMessage: string;
  socketAdapter: SocketAdapterService;
  socketSubscription: Subscription;
  taskId: number;
  kmsHost: string;
  lmsHost: string;
  profileservice: any;
  pagename: string;
  unreadMessages: any[];
  chatService: ChatService;
  currentUser: any;
  visible: boolean = false;
  showLanguage: boolean = false;
  idleState: string = 'NOT_STARTED';
  timedOut = false;
  lastPing: Date = null;
  isassign: boolean = true;
  primaryUser: any;
  userRole: any;

  setFocus1: boolean;
  setFocus2: boolean;
  setFocus3: boolean;
  chatbotEnable: boolean = environment.chatbotEnable;
  getUserReportingRole: boolean;
  private _router = inject(Router);
  private notificationInterval: Subscription;
  roleOptions: any[] = [];
  selectedRole: string = '';
  userRoleVisiable: boolean = false;
  roleChangeMsg: string = '';
  selectedRoleObj: any;

  visibleMenuItems: any;
  showSwitchRoleModal: boolean = false;

  constructor(
    injector: Injector,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private _mailNotificationService: MailNotificationService,
    private breakpointObserver: BreakpointObserver,
    private el: ElementRef,
    private renderer: Renderer2,
    private idle: Idle,
    private titleService: Title
  ) {
    this.alertService = injector.get<AlertService>(AlertService);
    this.appService = injector.get<AppService>(AppService);
    this.localstorage = injector.get<LocalService>(LocalService);
    this.profileservice = injector.get<ProfileService>(ProfileService);
    this.socketAdapter = injector.get<SocketAdapterService>(SocketAdapterService);
    this.chatService = injector.get<ChatService>(ChatService);
    this.display = false;
    this.username = sessionStorage.getItem('username') || '';
    this.userDetails = JSON.parse(this.localstorage.getItem('userDetails'));
    this.primaryUser = JSON.parse(sessionStorage.getItem('primaryuser'));
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
    this.userRole = sessionStorage.getItem('role_name');
    this.kmsHost = environment.KMS_URL;
    this.lmsHost = environment.LMS_URL;
    const page = location.pathname.split('/')[2];
    this.currentPage = AppConstants.pages.find(p => p.page === page);
    this.appService.currentState.subscribe(data => {
      if (data.key === 'currentPage' && data.value !== 'help-desk') {
        this.currentPage = AppConstants.pages.find(p => p.page === data.value);
        this.pageIcon = data.value?.additionalinfo?.icon;
        this.pagename = data.value?.name;
      }
      if (data.key === 'dynamicPages') {
        this.currentPage = AppConstants.pages.find(p => p.page === 'dynamicPages');
        this.currentPage.title = data.value.pagename ? data.value.pagename : '';
        this.pageIcon = data.value.additionalinfo.icon;
        this.pagename = data.value?.name;
      }
    });
    if (this._router.url === '/pages/main-notification') {
      this.showCount = true;
    }

    this.breakpointObserver.observe(['(max-width: 767px)']).subscribe((result: BreakpointState) => {
      if (result.matches) {
        this.sidebarMenu = false;
      } else {
        this.sidebarMenu = true;
      }
    });
    this._mailNotificationService.notificationCount.subscribe(n => (this.notificationCount = n));
    this.statuses = [
      { name: 'Available', code: 'Available' },
      { name: 'Not Available', code: 'Not Available' }
    ];
    this.watchIdleTime();
    this.idle.watch();
  }

  ngAfterViewChecked(): void {
    if (this.accept && this.setFocus1) {
      setTimeout(() => {
        this.accept.nativeElement.focus();
      }, 200);
      this.setFocus1 = false;
    }
    if (this.langselect && this.setFocus2) {
      this.langselect.nativeElement.focus();
      this.setFocus2 = false;
    }
    if (this.setFocus3) {
      let googleTranElement = document.getElementById('google_translate_element');
      googleTranElement.getElementsByTagName('select')[0].focus();
      this.setFocus3 = false;
    }
    this.removeAttribute(document.getElementsByClassName('p-sidebar'), 'aria-modal');
    this.removeAttribute(document.getElementsByClassName('p-sidebar-active'), 'aria-modal');
    this.removeAttribute(document.getElementsByClassName('dx-dropdownmenu-button'), 'role');
    this.setAttribute(document.getElementsByClassName('dx-texteditor-input'), 'aria-label', 'input');
    this.setAttribute(document.getElementsByClassName('p-sidebar-close'), 'aria-label', 'close');
    this.setAttribute(document.getElementsByClassName('p-paginator-prev'), 'aria-label', 'Previous');
    this.setAttribute(document.getElementsByClassName('p-paginator-next'), 'aria-label', 'Next');
    this.setAttribute(document.getElementsByClassName('p-inputnumber-input'), 'aria-label', 'Number');
    this.setAttribute(document.getElementsByClassName('dx-menu-item'), 'aria-label', 'menu');
    this.setAttribute(document.getElementsByClassName('p-datepicker-trigger'), 'aria-label', 'calendar');
    this.setAttribute(document.getElementsByClassName('p-datepicker-prev'), 'aria-label', 'Previous');
    this.setAttribute(document.getElementsByClassName('p-datepicker-next'), 'aria-label', 'Next');
    this.setAttribute(document.getElementsByClassName('p-dialog-header-close'), 'aria-label', 'Close');

    const links = this.el.nativeElement.querySelectorAll('.p-menuitem-link');
    links.forEach((link: HTMLElement) => {
      this.renderer.removeAttribute(link, 'role');
    });
  }
  removeAttribute(comp: any, attr) {
    if (comp && comp.length > 0) {
      Object.values(comp).forEach((element: any) => {
        element.removeAttribute(attr);
      });
    }
  }
  setAttribute(comp: any, attr, val) {
    if (comp && comp.length > 0) {
      Object.values(comp).forEach((element: any) => {
        element.setAttribute(attr, val);
      });
    }
  }

  ngOnInit(): void {
    this.showLanguage = sessionStorage.getItem('showLanguagePage') == 'false' ? false : true;
    sessionStorage.setItem('showLanguagePage', '');
    sessionStorage.setItem('isPage', '');
    this.loadMenuList();
    this.getUnreadMessages();
    this.chatService.loadActiveGroupsGlobally();
    this.socketAdapter.getUnreadMessages().subscribe(messages => {
      if (!Array.isArray(messages)) {
        this.getUnreadMessages();
        return;
      }

      // Check if all messages in the payload are ghost group notifications
      const allGhostMessages = messages.length > 0 && messages.every(msg => {
        const groupId = msg.groupId || msg.group_id || msg.meta_id || (msg.isGroup ? msg.id : null);
        if (groupId && this.chatService.activeGroupsLoaded) {
          const isActive = this.chatService.activeGroupIds.some(id => String(id) === String(groupId));
          if (!isActive) {
            console.warn('Ignored ghost notification for group:', groupId);
            return true;
          }
        }
        return false;
      });

      // If they are not all ghost messages, trigger the REST API to get the true unread count
      if (!allGhostMessages) {
        this.getUnreadMessages();
      }
    });
    this.profileservice.setUserPreference();
    this.getAuthMe();
    this.initializeResetPasswordForm();
    this.getNotificationList();
    this.notificationInterval = interval(MAIN_NOTIFICATION_TIMER).subscribe(() => {
      this.getNotificationList();
    });
    this.profileservice.profileImage.subscribe((img: any) => {
      this.thumbnail = img.url ? img.url : 'assets/images/user-empty.png';
      this.showname = img.name;
    });

    this.getMultiRoles();
    this.listenToRouteTitle();
  }

  ngOnDestroy(): void {
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }
    this.socketAdapter.stopChatListeners();
    if (this.notificationInterval) {
      this.notificationInterval.unsubscribe();
    }
    this.localstorage.removeItem('SELECTED_THEME');
    let googleTranElement = document.getElementById('google_translate_element');
    googleTranElement.className = 'clsLangTrans d-none';
    sessionStorage.setItem('isPage', '');
  }

  pollUnNotified() {
    setInterval(() => {
      this.authService.getUnNotified().subscribe(({ data: _notification }: any) => {
        const userId = this.localstorage.getItem('id');
        if (Number(userId) === Number(_notification?.user_id) && !this.modalService.hasOpenModals()) {
          this.taskId = _notification.id;
          this.notificationMessage = _notification?.task_name;
          this.modalService.open(this.notificationAlert);
        }
      });
    }, 5000);
  }

  updateNotification() {
    this.authService.updateUnNotified({ id: this.taskId }).subscribe(_data => {
      this.modalService.dismissAll();
    });
  }

  getWorkerAvailability() {
    this.authService.getWorkerAvailability().subscribe((res: any) => {
      if (res && res.data) {
        const status = res.data.worker_availablity;
        const currentStatus = sessionStorage.getItem('availability');
        if (status === 'Available') {
          if (currentStatus !== 'Available') {
            this.updateStatus('Not Available');
          }
        }
        this.selectedStatus = status;
      }
    });
  }

  updateStatus(e) {
    const reqBody = {
      workerAvailablity: e
    };
    sessionStorage.setItem('availability', e);
    this.authService.updateWorkerAvailability(reqBody).subscribe(() => {
      this.selectedStatus = e;
    });
  }

  connectSocket() {
    const user_id = this.localstorage.getItem('id');
    this.socketSubscription = this.socketAdapter.receivedNotification().subscribe(data => {
      if (Number(user_id) === Number(data?.userId)) {
        this.notificationMessage = data?.taskName;
        this.modalService.open(this.notificationAlert);
      }
    });
  }

  organisationSelect(eve: any) {
    this.authService.feedOrgInfo(eve.node.id);
    sessionStorage.setItem('orgid', eve.node.id);
  }

  getUserOrgList() {
    this.authService.getUserOrgList().subscribe({
      next: (res: any) => {
        this.orgOptions = res.data;
        this.selectedOrg = res.data[0];
        this.authService.feedOrgInfo(res.data[0].id);
        sessionStorage.setItem('orgid', res.data[0].id);
        if (this.orgOptions[0].children.length) {
          this.disable = false;
        } else {
          this.orgName = this.orgOptions[0].name;
          this.disable = true;
        }
      },
      error: err => {
        console.log(err);
      }
    });
  }

  getUnreadMessages() {
    this.chatService.getUnreadMessages().subscribe({
      next: (res: any) => {
        this.unreadMessages = res['data'];
      },
      error: _err => {
        this.alertService.error(AppConstants.errorMessage);
      }
    });
  }
  roleChange(rolename: any) {
    let userRole = JSON.parse(sessionStorage.getItem('userrole'));
    let roleid;
    userRole.userroles.forEach((key: any) => {
      if (key.name == rolename) {
        roleid = key.id;
      }
    });
    this.isassign = rolename == 'dfcsstaff' ? true : false;
    this.authService.getUserRoleChange(roleid, rolename);
  }

  getAuthMe() {
    this.authService.getAuthMe().subscribe({
      next: (res: any) => {
        if (res.data) {
          const userid = res.data.id;
          this.authService.getUserRole(userid).subscribe(response => {
            if (response) {
              this.showname = response.data.firstname;
              this.thumbnail = response.data?.additionalinfo?.thumbnail?.url || 'assets/images/user-empty.png';
              let roleId;
              let roleName;
              let oldRoleId =
                sessionStorage.getItem('role_id') !== 'undefined' ? sessionStorage.getItem('role_id') : null;
              let oldRoleName =
                sessionStorage.getItem('role_name') !== 'undefined' ? sessionStorage.getItem('role_name') : null;
              response.data?.userroles.forEach(role => {
                if (oldRoleId && oldRoleName) {
                  if (role.id == oldRoleId) {
                    roleId = role.id;
                    roleName = role.name;
                  } else {
                    const index: number = response.data?.userroles.indexOf(role);
                    if (index !== -1) {
                      response.data?.userroles.splice(index, 1);
                    }
                  }
                } else if (role.isprimary !== null || role.isprimary !== undefined) {
                  if (role.isprimary) {
                    roleId = role.id;
                    roleName = role.name;
                  } else {
                    const index: number = response.data?.userroles.indexOf(role);
                    if (index !== -1) {
                      response.data?.userroles.splice(index, 1);
                    }
                  }
                }
              });

              if (!oldRoleId && !oldRoleName) {
                sessionStorage.setItem('role_id', roleId);
                sessionStorage.setItem('role_name', roleName);
                if (roleId && roleId !== undefined) this.isassign = roleName == 'dfcsstaff' ? true : false;
              } else {
                if (oldRoleId && oldRoleId !== undefined) this.isassign = oldRoleName == 'dfcsstaff' ? true : false;
              }
              sessionStorage.setItem('user', JSON.stringify(response.data));
              sessionStorage.setItem('menuPermissions', JSON.stringify(res['data'].menu_permissions));
            }
          });
        }
      },
      error: err => {
        console.log(err);
      }
    });
  }

  onLoggedout() {
    const currentStatus = sessionStorage.getItem('availability');
    if (currentStatus === 'Available') {
      this.updateStatus('Not Available');
    }
    this.authService.resetLoggedIn();
    this.authService.logout();
  }
  gotoEmailTemp() {
    this.navigationTO('pages/email-template');
  }

  routeToChat() {
    this._router.navigate(['/pages/chat/history']);
  }

  gotoVideoConfig() {
    const url = this._router.serializeUrl(this._router.createUrlTree([`/video-conferencing/${this.generateGuid()}`]));
    window.open(url, '_blank');
  }
  generateGuid(): string {
    return (
      'card-inal-' +
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.floor((AppConstants.generateNumber() * 16) / AppConstants.generateNumber());
        const v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      })
    );
  }

  showDialog(changepassword) {
    this.display = true;
    this.modalService
      .open(changepassword, { size: 'md', backdrop: 'static', windowClass: 'changepassword' })
      .result.then();
    this.initializeResetPasswordForm();
  }

  get resetFormcontrols() {
    const isInvalid = this.resetPasswordForm.controls['newpassword'].status;
    const newpassword = this.resetPasswordForm.value['newpassword'];
    const conformpassword = this.resetPasswordForm.value['conformpassword'];
    if (isInvalid === 'INVALID' && newpassword !== '') {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
    if (newpassword !== conformpassword) {
      this.resetPasswordForm.get('conformpassword').setErrors({ NoPassswordMatch: true });
    }
    return this.resetPasswordForm.controls;
  }

  initializeResetPasswordForm() {
    this.resetPasswordForm = this.formBuilder.group({
      id: sessionStorage.getItem('id'),
      mailid: sessionStorage.getItem('email'),
      currentpassword: ['', Validators.required],
      newpassword: [
        '',
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(/\d/, { hasNumber: true }),
          CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
          CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
          CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
          Validators.minLength(8)
        ])
      ],
      conformpassword: ['', Validators.required]
    });
  }
  changePassword() {
    const obj = {
      id: Number(this.resetPasswordForm.value['id']),
      currentpassword: this.resetPasswordForm.value['currentpassword'],
      newpassword: this.resetPasswordForm.value['newpassword']
    };
    this.authService.ResetPassword(obj).subscribe({
      next: _res => {
        this.authService.logout();
        this.alertService.success('Password Changed Successfully.');
        this.display = false;
        this.modalService.dismissAll('changepassword');
      },
      error: _err => this.alertService.error('Something went wrong.')
    });
  }
  goToHelpDesk() {
    const url = this._router.serializeUrl(this._router.createUrlTree(['/pages/help-desk/videos']));
    this.appService.addValue('currentPage', 'help-desk');
    window.open(url, '_blank');
  }
  openActivity() {
    this.active = !this.active;
    this.visibleSidebar2 = true;
    this.activityLogPageload = Promise.resolve(true);
  }
  gotoNotification() {
    this.navigationTO('pages/main-notification');
    this.showCount = true;
  }
  navigationTO(url) {
    this._router.navigateByUrl(url).then(() => {
      this._router.navigated = false;
      this._router.navigate([url], { replaceUrl: true });
    });
  }
  getNotificationList() {
    this._mailNotificationService.getNotificationList().subscribe((res: any) => {
      if (res) {
        const notificationCount = res.data;
        this.notificationCount = notificationCount?.length > 0 ? notificationCount?.length : 0;
        const count = res.data?.filter(n => n.isnew);
        const totalCount = count?.length ? count.length : 0;
        this._mailNotificationService.getNotificationCount(totalCount);
      }
    });
  }

  sidebar() {
    this.sidebarMenu = !this.sidebarMenu;
  }

  showLanguageDialog() {
    this.visible = true;
    this.setFocus1 = true;
  }
  acceptLanguage() {
    this.visible = false;
    this.showLanguage = false;
    this.setFocus3 = true;
    sessionStorage.setItem('showLanguagePage', '');
    sessionStorage.setItem('isPage', 'true');
    let googleTranElement = document.getElementById('google_translate_element');
    googleTranElement.className = 'clsLangTrans';
  }
  watchIdleTime() {
    if (sessionStorage.getItem('jwt-token')) {
      let idletimeoutsec = sessionStorage.getItem('idletimeoutsec')
        ? Number(sessionStorage.getItem('idletimeoutsec'))
        : 1800;
      this.idle.setIdle(idletimeoutsec); // this will be 58*60

      this.idle.setTimeout(5); //counter time.

      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // there are various Interupts

      this.idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No Longer Idle';
      }); // this is the palce to do somthing if user comes back after being idle.

      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        if (this.modalService.hasOpenModals()) {
          this.modalService.dismissAll();
        }
        this.authService.logout();
      }); // this is place for redirect to login page.

      this.idle.onIdleStart.subscribe(() => {
        this.idleState = 'You have gone Idle';
      }); // this is place to do somthing when user goes Idle.

      this.idle.onTimeoutWarning.subscribe(countdown => {
        this.idleState = 'You will time out in ' + countdown + 'seconds';
      }); // this is the place for alert to notify of the logout
    } else {
      this.idle.stop();
    }
  }

  close() {
    this.visible = false;
    this.setFocus2 = true;
  }

  getMultiRoles() {
    this.authService.getMultiRole().subscribe({
      next: (roles: any) => {
        this.roleOptions = roles;
        this.selectedRole = this.resolveSelectedRole(roles);
      },
      error: err => {
        console.error(err.name);
      }
    });
  }
  onDropdownShow() {
    document.body.classList.add('p-select-scroll-lock');
  }
  roleVisiableclose() {
    this.userRoleVisiable = false;
    this.selectedRole = this.resolveSelectedRole(this.roleOptions);
    this.selectedRoleObj = null;
  }
  onRoleChange(roleCd: string) {
    this.selectedRoleObj = this.roleOptions.find(r => r.roleCd === roleCd);
    this.selectedRole = roleCd;
    this.userRoleVisiable = true;
    this.roleChangeMsg = `Are you sure you want to Login as a ${this.selectedRoleObj?.roleName}?`;
  }

  confirmChangeRole() {
    if (!this.selectedRoleObj) {
      this.roleVisiableclose();
      return;
    }
    const isPrimary = this.getUserPrimaryRole();
    const info = {
      roleId: this.selectedRoleObj.roleId,
      is_default: isPrimary == this.selectedRoleObj.roleCd ? true : false
    };
    this.authService.multiRolesChange(this.selectedRoleObj.roleId, info).subscribe({
      next: (res: any) => {
        if (res['data']) {
          this.authService.getUserRoleChange(this.selectedRoleObj.roleId, this.selectedRoleObj.roleName);
          this.roleVisiableclose();
        }
      },
      error: err => {
        console.log(err.name);
        this.alertService.error(AppConstants.errorMessage);
      }
    });
  }

  resolveSelectedRole(roles: any): string {
    const sessionRole = this.userDetails?.role;
    if (!sessionRole) return '';
    const byCd = roles.find((r: any) => r.roleCd == sessionRole);
    if (byCd) return byCd.roleCd;
    return '';
  }

  getUserPrimaryRole() {
    const userRoles = JSON.parse(this.localstorage.getItem('userrole') || '{}');
    return userRoles?.userroles?.find((item: any) => item?.isprimary)?.name || '';
  }

  listenToRouteTitle() {
    this.setTitleFromUrl(this._router.url);
    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.setTitleFromUrl(event.urlAfterRedirects);
    });
  }

  setTitleFromUrl(url: string) {
    const segments = url.split('/').filter(s => s && s !== 'pages');
    const lastSegment = segments[segments.length - 1]?.split('?')[0];

    const match = page_title.find(p => p.page === lastSegment);

    if (match) {
      this.titleService.setTitle(match.title);
    } else {
      for (const segment of [...segments].reverse()) {
        const segmentMatch = page_title.find(p => p.page === segment);
        if (segmentMatch) {
          this.titleService.setTitle(segmentMatch.title);
          return;
        }
      }
      this.titleService.setTitle('COMET - Communication & Operations Mobile Engagement Tool');
    }
  }

  loadMenuList() {
    const userRole = JSON.parse(sessionStorage.getItem('userrole') || '{}');
    this.getUserReportingRole = userRole?.isreportingrole === true;
    const userRoles = userRole?.userroles?.filter((role: any) => !role?.isprimary);
    const menuList = [
      {
        label: 'My Profile',
        key: 'MyProfile',
        isShow: true,
        command: () => this.handleMenu('myProfile')
      },
      {
        label: 'Change Password',
        key: 'ChangePassword',
        isShow: false,
        command: () => this.handleMenu('changePassword')
      },
      {
        label: 'Switch Role',
        key: 'SwitchRole',
        isShow: userRoles.length > 0 || false,
        command: () => this.handleMenu('switchRole')
      }
    ];

    this.visibleMenuItems = menuList.filter((res: any) => res.isShow);
  }

  handleMenu(type: string): void {
    switch (type) {
      case 'myProfile': {
        this._router.navigate(['/pages/profile']);
        break;
      }
      case 'switchRole': {
        this.showSwitchRoleModal = true;
        break;
      }
    }
  }
}
